import Modal from '../../shared/components/Modal';

const PersonalInformation = ({ showPersonalInformationModal, closePersonalInformationModal }) => {
  return (
    <Modal show={showPersonalInformationModal} closeModal={closePersonalInformationModal}>
      <div className={'w-[300px] text-[14px] mt-[40px]'}>
        귀하는 개인(신용) 정보의 선택적인 수집∙이용, 제공에 대한 동의를 거부할 수 있습니다. 다만, 동의하지 않을 경우 관련 편의제공(이용권 등록) 안내 등 이용 목적에 따른 혜택에 제한이 있을 수 있습니다.
        그 밖에 이용과 관련된 불이익은 없습니다.
        <br/>
        <br/>
        1. 수집 및 이용목적
        <br/>
        이용권 제공, 고객에 대한 편의제공
        <br/>
        2. 수집 및 이용 항목
        <br/>
        - 개인식별정보: 휴대전화 번호
        <br/>
        3. 보유기간
        <br/>
        동의 일로부터 5년 혹은 고객 삭제 요청 시까지
      </div>
    </Modal>
  );
};

export default PersonalInformation;
